import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { GoLocation } from "react-icons/go";
import { FiPhone } from "react-icons/fi";
import { BsEnvelope } from "react-icons/bs";
import "tachyons";

export default () => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            siteTitle: title
            mailChimpUrl
            pinterest
            facebook
            twitter
            youtube
            github
          }
        }
      }
    `}
    render={(data) => (
      <footer className="bg-dark-gray near-white sans-serif lh-copy">
        <div
          className="flex flex-wrap mw9 justify-between center w-100 mt2"
          style={{ padding: "40px 0px 40px 0px" }}
        >
          <div className="flex flex-column ml2 mr2">
            <span className="near-white f5 tracked mb2 db lh-copy mt0">
              Thông tin liên hệ
            </span>

            <div>
              <a className="fl mt0 mb2 no-underline" href="https://www.google.com/maps/place/Tr%C6%B0%E1%BB%9Dng+%C4%90%E1%BA%A1i+H%E1%BB%8Dc+Quy+Nh%C6%A1n/@13.7580929,109.2164983,17z/data=!3m1!4b1!4m5!3m4!1s0x316f6cebf252c49f:0xa83caa291737172f!8m2!3d13.7580877!4d109.218687?hl=vi-VN">
                <GoLocation className="fl" style={{ color: "#f2184f", marginTop: "0.1em" }} />{" "}
                <b className="ml2 f7" style={{ color: "#777777" }}>
                  Địa chỉ: Phòng Khoa học công nghệ & Hợp tác quốc tế - Trường
                  Đại học Quy Nhơn. Số 170 An Dương Vương, TP Quy Nhơn
                </b>
              </a>
            </div>
            <div>
              <a className="fl mt0 mb2 no-underline" href="tel:02563846817">
                <FiPhone className="fl" style={{ color: "#f2184f", marginTop: "0.2em" }} />{" "}
                <b className="ml2 f7" style={{ color: "#777777" }}>Số điện thoại: 0256 3846817</b>
              </a>
            </div>
            <div>
              <a className="fl mt0 mb2 no-underline" href="mailto:pkhcn@qnu.edu.vn">
                <BsEnvelope className="fl" style={{ color: "#f2184f", marginTop: "0.3em" }} />{" "}
                <b className="ml2 f7" style={{ color: "#777777" }}>Email: pkhcn@qnu.edu.vn</b>
              </a>
            </div>
          </div>
        </div>
        <div className="w-100 silver f7 center sans-serif flex justify-around bg-black lh-copy">
          <p>Bản quyền thuộc Trường Đại học Quy Nhơn © 2021.</p>
        </div>
      </footer>
    )}
  />
);
